var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, CircularProgress, Tooltip, } from "@mui/material";
import { testAppendAttr } from "@smp/utils";
import clsx from "clsx";
import { forwardRef, useMemo } from "react";
import { useStyles } from "./ui_button.css";
export const UiButton = forwardRef((_a, ref) => {
    var { align, children, className, disabled, endIcon, endIconLoading, gutterBottom, gutterRight, isLoading, isRounded, startIconLoading, startIcon, tooltip, href, TooltipProps, textColor = "inherit" } = _a, props = __rest(_a, ["align", "children", "className", "disabled", "endIcon", "endIconLoading", "gutterBottom", "gutterRight", "isLoading", "isRounded", "startIconLoading", "startIcon", "tooltip", "href", "TooltipProps", "textColor"]);
    const classes = useStyles({
        align,
        gutterBottom,
        gutterRight,
        textColor,
    });
    const buttonDisabled = useMemo(() => disabled || startIconLoading || endIconLoading || !!isLoading, [disabled, endIconLoading, isLoading, startIconLoading]);
    const iconLoading = useMemo(() => _jsx(CircularProgress, { size: 24, color: "inherit" }), []);
    const button = useMemo(() => (_jsxs(Button, Object.assign({ href: href || "", classes: classes, className: clsx(className, classes.button, isRounded && classes.button_rounded), disabled: buttonDisabled, endIcon: endIconLoading ? iconLoading : endIcon, ref: ref, startIcon: startIconLoading ? iconLoading : startIcon }, testAppendAttr("class", "ui_button"), props, { children: [isLoading && (_jsx(CircularProgress, { className: classes.circular, color: "inherit" })), textColor !== "inherit" ? (_jsx("span", { className: classes.button__text, children: children })) : (children)] }))), [
        buttonDisabled,
        children,
        className,
        classes,
        endIcon,
        endIconLoading,
        href,
        iconLoading,
        isLoading,
        isRounded,
        props,
        ref,
        startIcon,
        startIconLoading,
        textColor,
    ]);
    return useMemo(() => (_jsx(Tooltip, Object.assign({ title: tooltip || "" }, TooltipProps, { children: tooltip && buttonDisabled ? (_jsx(Box, { component: "span", style: { display: "inline-block" }, width: props.fullWidth ? "100" : "auto", className: className, children: button })) : (button) }))), [
        TooltipProps,
        button,
        buttonDisabled,
        className,
        props.fullWidth,
        tooltip,
    ]);
});
//# sourceMappingURL=ui_button.js.map